<template>
  <div class="oms-tabs">
    <div v-if="panes.length > 1" class="oms-tab-btn center" @click="toLeft">
      <a-icon type="left" />
    </div>
    <div class="oms-tab-container" ref="container">
      <div class="oms-tab-wrapper" ref="wrapper" :style="{ left: scroll + 'px' }">
        <div
          :class="['oms-tab-item', act === item.path ? 'oms-tab-item-act' : '']"
          v-for="(item, index) in panes"
          :key="item.path"
          @click="toLink(item)"
        >
          <label class="oms-tab-item-title">{{ item.title }}</label>
          <div class="oms-tab-item-close center" @click.stop="toDel(index, act === item.path)">
            <a-icon type="close" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="panes.length > 1" class="oms-tab-btn center" @click="toRight">
      <a-icon type="right" />
    </div>
    <div v-if="panes.length > 1" class="oms-tab-btn center handle-btn" @click="delAll">
      <a-icon type="close-circle" />
    </div>
  </div>
</template>

<script>
// import { pointTools, traceClick } from "@/utils/point";

export default {
  props: {
    panes: {
      type: Array,
      default: () => [],
    },
    act: String,
  },
  data() {
    return {
      scroll: 0,
      containerWidth: 0,
      wrapperWidth: 0,
    };
  },
  watch: {
    panes() {
      this.scrollInit();
    },
  },
  mounted() {
    this.scrollInit();
  },
  methods: {
    scrollInit() {
      this.scrollFn();
      window.onresize = () => {
        this.scrollFn();
      };
    },
    scrollFn() {
      this.containerWidth = this.$refs.container.offsetWidth;
      this.wrapperWidth = this.$refs.wrapper.scrollWidth;
      this.scroll = 0;
    },
    toLeft() {
      if (this.wrapperWidth > this.containerWidth) {
        this.scroll += 80;
        if (this.scroll > 0) {
          this.scroll = 0;
        }
      }
    },
    toRight() {
      if (this.wrapperWidth > this.containerWidth) {
        this.scroll -= 80;
        if (this.scroll < this.containerWidth - this.wrapperWidth) {
          this.scroll = this.containerWidth - this.wrapperWidth;
        }
      }
    },
    toLink(item) {
      this.$router.push(item.path);
    },
    toDel(index, isCur) {
      this.$emit("del", { index, isCur });
    },
    delAll() {
      this.$emit("delAll");
    },
  },
};
</script>

<style lang="less" scoped>
@oms-tab: 32px;
@oms-tab-color: #5677f0;
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.oms-tabs {
  display: flex;
  align-items: center;
  user-select: none;
  width: 100%;
  height: @oms-tab;

  .oms-tab-container {
    flex: 1;
    height: @oms-tab;
    overflow: hidden;
    position: relative;

    .oms-tab-wrapper {
      display: flex;
      align-items: center;
      height: 100%;
      transition: 0.3s;
      position: absolute;
      left: 0;
    }

    .oms-tab-item {
      box-sizing: border-box;
      border: 1px solid #e5eaed;
      border-radius: 5px;
      padding: 0 12px;
      margin: 0 5px;
      flex-shrink: 0;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      position: relative;
      color: #999999;

      .oms-tab-item-title {
        cursor: pointer;
        position: relative;
        left: 0;
        transition: 0.2s;
      }

      .oms-tab-item-close {
        height: 100%;
        font-size: 10px;
        box-sizing: border-box;
        cursor: pointer;
        display: none;
        position: absolute;
        top: 0;
        right: 3px;
      }

      &.oms-tab-item-act {
        background: @oms-tab-color;
        color: #fff;
      }

      &:hover {
        background: @oms-tab-color;
        color: #fff;

        .oms-tab-item-title {
          left: -5px;
        }

        .oms-tab-item-close {
          display: flex;
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .oms-tab-btn {
    width: @oms-tab;
    height: @oms-tab;
    cursor: pointer;
    flex-shrink: 0;
    background: #fff;

    &:hover {
      color: @oms-tab-color;
    }
  }

  .handle-btn {
    box-shadow: -5px 0 10px -5px #ccc;
  }
}
</style>
